import { Box, Divider, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { DocumentRowSkeleton } from "web_myplann/Portfolio/Components/Redesign/Documents/DocumentRowSkeleton";
import { RedesignListBackground } from "web_myplann/Shared/Components/Redesign/RedesignListBackground";

const NUMBER_OF_ROWS = 6;

export const DocumentListSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<RedesignListBackground pt={theme.spacingTokens.sm}>
			<Box bgcolor="background.paper">
				<Stack divider={<Divider redesigned />}>
					{Array.from({ length: NUMBER_OF_ROWS }).map((_, index) => (
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
						<DocumentRowSkeleton key={index} />
					))}
				</Stack>
			</Box>
		</RedesignListBackground>
	);
};
